export namespace DISCOUNT_TYPE {
    export const DISCOUNT_NONE = "none"
    export const DISCOUNT_CURRENCY_VALUE = "currency-value"
    export const DISCOUNT_PERCENT_BEFORE_TAXES = "percent-before-taxes"
}
export type DISCOUNT_TYPE = typeof DISCOUNT_TYPE[keyof typeof DISCOUNT_TYPE]


// WEBPACK FOOTER //
// ./src/state/pricing/DiscountType.ts